"use client"
import { useIsSticky } from "../../hooks"
import { classNames } from "../../utils"
import { SpaceBetween, type SpaceBetweenProps } from "../SpaceBetween"
import { TextBody, type TextBodyProps } from "../Text"

export type ListHeaderProps = SpaceBetweenProps

const ListHeader = ({ className, ...rest }: ListHeaderProps) => {
  const { ref, isSticky } = useIsSticky()
  return (
    <SpaceBetween
      className={classNames(
        "-top-px sticky border-border-2 border-b bg-inherit p-4",
        isSticky && "shadow-sm",
        className,
      )}
      ref={ref}
      {...rest}
    />
  )
}

export const ListHeaderTitle = ({
  size = "xs",
  weight = "semibold",
  ...rest
}: TextBodyProps) => {
  return (
    <TextBody color="text-secondary" size={size} weight={weight} {...rest} />
  )
}

export { ListHeader }
